<template>
  <div class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto" id="popup-content"
    @click.self="closeModal">
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:px-[24px] md:py-[40px] overflow-auto">
      <div class="flex items-center justify-between">
        <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
          View Purchase Order
        </p>
        <button class="text-2xl text-[#353535] cursor-pointer outline-none focus:outline-none" type="button"
          @click="closeModal">
          <span class="mdi text-xl mdi-close"></span>
        </button>
      </div>
      <div class="bg-white px-[12px] md:px-[24px] py-[32px] mt-[16px] rounded-[4px]">
        <div class="flex justify-between items-center">
          <h2 class="font-bold text-[20px] leading-[20px] text-[#2463EB] w-full">
            Order # {{ purchaseOrder.orderNumber }}
          </h2>
          <button v-if="
            getStatus(purchaseOrder.status) === 'draft' ||
            getStatus(purchaseOrder.status) === 'submitted'
          " class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-normal text-[14px] border-solid px-[24px] py-[12px] flex items-center gap-[5px] flex items-center gap-[5px]"
            @click="viewEdit(dataID)">
            <img src="/assets/icon/edit-2.svg" alt="" />
            Edit
          </button>
        </div>
        <div class="flex flex-col md:flex-row items-start gap-2md:items-center md:gap-4 mt-2">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            Order For
          </h2>
          <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ purchaseOrder.buyerName }}</span>
        </div>
        <div v-if="purchaseOrder.buyerContactPhoneNumber"
          class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[40px]">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            Contact Number
          </h2>
          <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
            purchaseOrder.buyerContactPhoneNumber
              ? purchaseOrder.buyerContactPhoneNumber
              : ""
          }}</span>
        </div>
        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            Contact Email
          </h2>
          <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ purchaseOrder.buyerContactEmail
          }}</span>
        </div>
        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            Address
          </h2>
          <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ purchaseOrder.buyerAddress }}</span>
        </div>
        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            Created
          </h2>
          <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ formatDate(purchaseOrder.created)
          }}</span>
        </div>
        <div v-if="purchaseOrder.approvedAt"
          class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            Approval Date
          </h2>
          <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ formatDate(purchaseOrder.approvedAt)
          }}</span>
        </div>
        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            SAP Number
          </h2>

          <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ getSapInfo(purchaseOrder) }}</span>
        </div>
        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            Order Status
          </h2>
          <span class="flex items-center gap-[5px] max-w-max w-fullpx-[5px]" :class="[
            'badge',
            {
              'badge-success': getStatus(purchaseOrder.status) === 'approved',
            },
            {
              'badge-danger': getStatus(purchaseOrder.status) === 'rejected',
            },
            {
              'badge-secondary':
                getStatus(purchaseOrder.status) === 'closed' || 'draft',
            },
            {
              'badge-warning':
                getStatus(purchaseOrder.status) === 'submitted',
            },
          ]">
            <span class="inline-block w-[10px] h-[10px] rounded-[1px]" :style="{
              backgroundColor:
                getStatus(purchaseOrder.status) === 'approved'
                  ? '#16a249'
                  : getStatus(purchaseOrder.status) === 'submitted'
                    ? '#FFA500'
                    : getStatus(purchaseOrder.status) === 'rejected'
                      ? '#e42728'
                      : getStatus(purchaseOrder.status) === 'closed' || 'draft'
                        ? '#ccc'
                        : '',
            }"></span>
            <span class="text-[12px] font-normal leading-[16.94px]">
              {{
                getStatus(purchaseOrder.status) === "approved"
                  ? "Approved"
                  : getStatus(purchaseOrder.status) === "closed"
                    ? "Closed"
                    : getStatus(purchaseOrder.status) === "submitted"
                      ? "Submitted"
                      : getStatus(purchaseOrder.status) === "rejected"
                        ? "Rejected"
                        : getStatus(purchaseOrder.status) === "draft"
                          ? "Draft"
                          : getStatus(purchaseOrder.status)
              }}
            </span>
          </span>
        </div>
      </div>
      <div class="bg-white px-[12px] md:px-[24px] py-[32px] mt-[16px] rounded-[4px]">
        <div class="table-responsive">
          <table class="table m-0 p-0 text-nowrap">
            <thead class="bg-[#ECF9FF]">
              <tr>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Item #
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Description
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Quantity
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in purchaseOrder.details" :key="item.id">
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  {{ index + 1 }}
                </td>
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  {{ item.description }}

                  <div class="mt-[10px]" v-if="purchaseOrder.status === 'approved'">
                    <p class="italic text-[12px] font-normal text-slate-500">
                      {{
                        justOpenQuantities[index] !== undefined
                          ? justOpenQuantities[index]
                          : "N/A"
                      }}
                      {{ item.description }}
                      left for delivery
                    </p>
                  </div>
                </td>
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  {{ item.quantity }}
                </td>
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  &#8358;{{ formatMoney(item.quantity * item.price) }}
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
                  Subtotal
                </td>
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  &#8358; {{ formatMoney(total) }}
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
                  Total Payable
                </td>
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  &#8358; {{ formatMoney(total - amountPaid) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";
import ItemDetails from "../SettingsPurchaseOrder/PurchaseOrderItemDetails";
export default {
  props: [
    "closeModal",
    "purchaseOrder",
    "paymentHistory",
    "viewEdit",
    "dataID",
  ],
  component: {
    ItemDetails,
  },
  data() {
    return {
      sellerBusinessName: "",
      openQuantities: [],
      justOpenQuantities: [],
    };
  },
  async mounted() {
    this.justOpenQuantities = await this.getOpenQuantities();
  },
  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },

    total: function () {
      let amount = 0;
      this.purchaseOrder.details.forEach(
        (i) => (amount += i.quantity * i.price)
      );
      return amount;
    },

    amountPaid: function () {
      let amountPaid = 0;
      this.paymentHistory.forEach((i) => (amountPaid += i.amountPaid));
      return amountPaid;
    },
  },
  methods: {
    getSapInfo(order) {
      const orderStatus = order.status.toLowerCase();

      if (orderStatus === "rejected" || orderStatus === "cancelled") {
        return "***";
      }
      if (orderStatus === "submitted" || orderStatus === "draft") {
        return "Awaiting approval";
      }
      return order.sapSalesOrderNumber || "No SAP number";
    },
    async getOpenQuantities() {
      try {
        const res = await this.$http.get(
          `/PurchaseOrders/${this.dataID}/getOpenQuantities`
        );

        if (res && res.data && res.data.orderQuantityStatuses) {
          this.openQuantities = res.data;
          const justOpenQuantities = this.openQuantities.orderQuantityStatuses.map(
            (status) => status.openQuantity
          );
          return justOpenQuantities;
        }
      } catch (err) {
        console.error("Failed to fetch open quantities:", err);
      }
    },
    getStatus(status) {
      return status ? status.toLowerCase() : "";
    },
    formatMoney(val) {
      const roundedVal = Math.round(val * 100) / 100;
      return helper.formatMoney(roundedVal);
    },

    formatDate(date) {
      if (date) return moment(date).format("lll");
      else return "";
    },
  },
};
</script>
